/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_SelectionInputs */



/**
* | output |
* | --- |
* | "Event selection" |
*
* @param {Event_SelectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_selection = /** @type {((inputs?: Event_SelectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_SelectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélection d’événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltungsauswahl")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezione dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбор мероприятия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Selección de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件选择")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट चयन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seleção de eventos")
	return /** @type {LocalizedString} */ ("Event selection")
});